import { styled } from '@linaria/react';
import { Flex } from '@vio/atlas/helpers/Flex';
const _exp = /*#__PURE__*/() => Flex.Row;
export const InputsWrapper = /*#__PURE__*/styled(_exp())({
  name: "InputsWrapper",
  class: "i1po9xid",
  propsAsIs: true
});
const _exp2 = /*#__PURE__*/() => Flex.Column;
export const InputWrapper = /*#__PURE__*/styled(_exp2())({
  name: "InputWrapper",
  class: "ibm1xrz",
  propsAsIs: true
});
const _exp3 = /*#__PURE__*/() => Flex.Row;
export const InputsSeparator = /*#__PURE__*/styled(_exp3())({
  name: "InputsSeparator",
  class: "inxfd81",
  propsAsIs: true
});
export const RangeSliderWrapper = /*#__PURE__*/styled('div')({
  name: "RangeSliderWrapper",
  class: "r1o6qarc",
  propsAsIs: false
});

// This is provider for styles from rc-slider library
// Currently we don't use css loader in webpack.
// It was removed during migration to a new webpack version.
// So we're not able to import style from npm modules.
// We use theme colors only for elements we're currently use on the website
export const RangeSliderStylesProvider = /*#__PURE__*/styled('div')({
  name: "RangeSliderStylesProvider",
  class: "r1pggm8n",
  propsAsIs: false
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");